import React, { Component, Fragment  } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import SearchBox from '../partials/SearchBox';
import { fetchConnectedCompanies } from '../../actions/companies';
import SearchableList from '../partials/SearchableList';
import SelectableListItem from '../partials/SelectableListItem';
import __ from '../../helpers/translation';
import localforage from "localforage";

const propTypes = {
  onSelected: PropTypes.func.isRequired,
  fetchConnectedCompanies: PropTypes.func.isRequired,
  currentItem: PropTypes.object
};


class CompanySelect extends Component {

    constructor (props) {
      super(props);
      this.searchList = React.createRef();
      this.companies = [];
      this.currentItem = props.currentItem ? props.currentItem : null;
      this.onSelected = props.onSelected;
      this.template = this.template.bind(this);
    }

    template(item){
      return <SelectableListItem 
        key={item.id.toString()}
        id={item.id.toString()}
        name={'companies'}
        title={item.name}
        selected={this.currentItem && this.currentItem.id == item.id}
        onSelect={() => this.onSelected(item)}
      />;
    }

    componentDidMount () {
      if(!window.navigator.onLine) {
        this.fn('bs_connected_companies').then(companies => {
          this.searchList.current.setState({
            items: companies,
            loading: false
          })
        })
        .catch(error => {
          return Promise.reject(error)
        })
      } 
      else {
        this.props.fetchConnectedCompanies()
          .then(data => {
            if(this.searchList.current) {
              this.searchList.current.setState({
                items: data.companies,
                loading: false
              })
            }
          })
          .catch(error => {
            return Promise.reject(error)
          })
      }
    }

    async fn (item) {
        await localforage.setDriver(localforage.INDEXEDDB)
        return await localforage.getItem(item);
    }

    render () {
        return (

          <Fragment>

              <h1 className="fw-600">{ __('app.inspections.title_company') }</h1>
              <SearchableList
                ref={this.searchList}
                template={this.template}
                items={this.companies}
                searchField={'name'}
                loading={true}
              />
          </Fragment>

        )
    }
}

CompanySelect.propTypes = propTypes;

const mapDispatchToProps = {
  fetchConnectedCompanies
};

export default connect(null, mapDispatchToProps)(CompanySelect);